import { PROMPT_ANSWER_STYLE } from '@core/const/const.PROMPT_ANSWER_STYLE';
import { PROMPT_CLASSIFY_IGNORED } from '@core/const/const.PROMPT_CLASSIFY_IGNORED';
import { PROMPT_CONTEXT } from '@core/const/const.PROMPT_CONTEXT';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@frontend/components/ui/card';
import { Separator } from '@frontend/components/ui/separator';
import { SettingsFeatureFlag } from '@frontend/Settings/components/SettingsFeatureFlag';
import { SettingsPrompt } from '@frontend/Settings/components/SettingsPrompt';
import { SettingsRecencyBias } from '@frontend/Settings/components/SettingsRecencyBias';

interface SettingsAnsweringProps {
  isReadOnly?: boolean;
}

export function SettingsAnswering({
  isReadOnly = false,
}: SettingsAnsweringProps) {
  return (
    <Card className="mt-12 max-w-[600px]">
      <CardHeader>
        <CardTitle>Answering questions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-3">
          <SettingsFeatureFlag
            feature={'ai_answer'}
            title="Answer questions in #channels"
            description="Let the Agent respond automatically if it knows the answer"
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsFeatureFlag
            feature={'respond_in_threads'}
            title="Answer follow-up questions in threads"
            description="Let the Agent respond to follow-up questions posted in threads, either when @mentioned or when the original asker asks a new question"
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsPrompt
            title="Answer instructions"
            description="Instruct the Agent how to answer questions"
            promptName="prompt_answer_style"
            defaultPrompt={PROMPT_ANSWER_STYLE}
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsPrompt
            title="Answer context"
            description="Insert company terms, acronyms and specific knowledge the agent should know"
            promptName="prompt_context"
            defaultPrompt={PROMPT_CONTEXT}
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsPrompt
            title="Which questions to ignore"
            description="Edit the Agent's prompt to avoid reacting to specific questions"
            promptName="prompt_classify_ignored"
            defaultPrompt={PROMPT_CLASSIFY_IGNORED}
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsFeatureFlag
            feature={'support_mode'}
            title="Support Mode"
            description="Enable automatic support case creation and tracking for questions"
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsFeatureFlag
            feature={'respond_to_bot_messages'}
            title="Respond to bot messages"
            description="Turn on to let QB respond to messages from other bots"
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsFeatureFlag
            feature={'image_context'}
            title="Image context"
            description="Use images attached to messages in Slack as additional context to the question"
            isReadOnly={isReadOnly}
          />
          <Separator />
          <SettingsRecencyBias isReadOnly={isReadOnly} />
          <Separator />
          <SettingsFeatureFlag
            feature={'eyes_reaction'}
            title="Eyes Reaction  👀"
            description="Show an eye reaction while checking for answers"
            isReadOnly={isReadOnly}
          />
        </div>
      </CardContent>
    </Card>
  );
}
